<template>
 <div class="card block-news-height">
            <div class="card-body pb-card-display p-element-page block-height-index">
                <div class="float-end">
                    <nuxt-link :to="routePath({name: 'imena-zivotinja'})">
                            <span class="text-muted font-size-13">
                               POGLEDAJ SVE                               
                            </span>   
                    </nuxt-link>                  
                </div> 
                <nuxt-link :to="routePath({name: 'imena-zivotinja'})">
                  <div class="card-title bc-title mb-4 font-size-13 text-uppercase">imena životinja</div>  
                </nuxt-link>    
                <hr>           
                  <div >
                    <nuxt-link v-for="(animal,i) in itemsSlice(animals.animals)" :key="i" class="d-flex align-items-center height-body w-100 text-dark" :to="routePath({name:'imena-zivotinja-animal',params:{animal: animal.description_path.split(' ').join('-').toLowerCase() }})">
                      <client-only>
                        <i :class="`esei icon-${animal.img} esei-default avatar-block text-white bg-${animal.color} p-1`"></i>  
                      </client-only> 
                        <p class="p-price-block"> {{animal.block}}</p>                     
                   </nuxt-link>                                        
                    </div>                      
                </div>
                <!-- data-sidebar-->
            </div>
  </template>
  
  <script setup>
  
   
  const routePath = useRoutePath()
  
  const props = defineProps({
    
    cols:{
   type: Number,
   require: true
 },
  xl:{
   type: Number,
   require: true,
   default: 4
 },
  lg:{
   type: Number,
   require: true,
   default: 4
 },
  md:{
   type: Number,
   require: true,
   default: 6
 },
  counter:{
   type: Number,
   require: true,
   default: 6
 },
 from:{
    type: Number,
    require: true,
    default: 0
 },
 display:{
   type:Boolean,
   default:true
 },
 display_avatar:{
      type:Boolean,
      default:true
  },
  display_avatar_food:{
      type:Boolean,
      default:true
  },
  others_page:{
    type:Boolean,
      default:false
  },
   
  category_name_ads:String
  })
 

  import animals  from '~/util/animal/animalName';
   
  
  
 
const itemsSlice = (items) => {

return items.slice(0, 8);

}
  
   
  </script>
  
  <style>
  
  </style>
